import './assets/main.css'

import App from '@/App.vue'
import langs from '@/langs'
import createAxiosInstance, { axiosInstance } from '@/plugins/axios'
import createSentryInstance from '@/plugins/sentry'
import { routes } from '@/routes'
import SerializerAuthenticated from '@/serializerAuthenticated.js'
import SerializerUnauthenticated from '@/serializerUnauthenticated.js'
import { all } from '@awesome.me/kit-56c2f179b2/icons'
import { createApiRequestParserPlugin } from '@expansivefm/api-request-parser'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import { createRouter, createWebHistory } from 'vue-router'

library.add(...all)

const router = createRouter({
  history: createWebHistory(),
  routes,
})

const pinia = createPinia()

pinia.use(piniaPluginPersistedstate)

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  warnHtmlInMessage: false,
  messages: {
    ...langs,
  },
})

export const globalT = i18n.global.t

const apiRequestParserAuthenticated = createApiRequestParserPlugin({
  prefix: 'authenticated',
  baseUrl: import.meta.env.VITE_API_PREFIX ?? 'engineer-app',
  serializer: new SerializerAuthenticated(),
  axios: axiosInstance,
})

const apiRequestParserUnauthenticated = createApiRequestParserPlugin({
  prefix: 'unauthenticated',
  baseUrl: import.meta.env.VITE_API_PREFIX ?? 'engineer-app',
  serializer: new SerializerUnauthenticated(),
  axios: axiosInstance,
})

const app = createApp(App)
  .component('font-awesome-icon', FontAwesomeIcon)
  .use(router)
  .use(pinia)
  .use(i18n)
  .use(apiRequestParserAuthenticated)
  .use(apiRequestParserUnauthenticated)
  .use(createAxiosInstance)
  .use(createSentryInstance)
  .mount('#app')
